import { DocumentData, QuerySnapshot } from 'firebase/firestore';

const getDataFromCollection = <T = DocumentData> (collection: QuerySnapshot<T> | undefined): T[] => {
  return collection?.docs.map(doc => doc.data()) ?? [];
};

export default getDataFromCollection;
